import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './style.scss';

const HighlightText = ({ text, className, highlightPart }) => {
    if (!highlightPart) return text || null;

    const parts = text?.split(new RegExp(`(${_.escapeRegExp(highlightPart)})`, 'gi')) || [];

    return (
        parts.map((part, index) => (
            <span key={index} className={`${part.toLowerCase() === highlightPart.toLowerCase() ? 'highlighted-text' : ''} ${className || ''}`}>
                {part}
            </span>
        ))
    );
};

HighlightText.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    highlightPart: PropTypes.string,
};

export default HighlightText;